'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-13d783d6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Clear = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ width: "48", height: "49", viewBox: "0 0 48 49" }, svgProps),
            React__default['default'].createElement("g", { fill: "none", fillRule: "evenodd" },
                React__default['default'].createElement("g", { transform: "translate(-318 -153)" },
                    React__default['default'].createElement("g", null,
                        React__default['default'].createElement("g", { stroke: "#323232" },
                            React__default['default'].createElement("path", { d: "M6.702.5h13.326v15H6.706L1.15 7.9 6.702.5z", transform: "translate(318 153.605) translate(13.49 16)" }),
                            React__default['default'].createElement("g", { strokeLinecap: "square" },
                                React__default['default'].createElement("path", { d: "M0.583 0.583L6.417 6.417", transform: "translate(318 153.605) translate(13.49 16) translate(8.71 4.43)" }),
                                React__default['default'].createElement("path", { d: "M0.583 0.583L6.417 6.417", transform: "translate(318 153.605) translate(13.49 16) translate(8.71 4.43) matrix(-1 0 0 1 7 0)" })))))))));
};

exports.default = Clear;
//# sourceMappingURL=index.js.map
